/* eslint-disable */
// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import { Plus, Edit, Trash2, Loader2, Upload, Eye, EyeOff, X, Check } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

import { API_URL, BACKEND_URL } from '../../config/api';
const API = `${BACKEND_URL}/api`;

const AdminBlog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingPost, setEditingPost] = useState(null);
  const [isCreating, setIsCreating] = useState(false);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API}/admin/blog`, { credentials: 'include' });
      if (response.ok) {
        const data = await response.json();
        setPosts(data);
      }
    } catch (error) {
      console.error('Error fetching posts:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (postId) => {
    if (!window.confirm('Supprimer cet article ?')) return;
    
    try {
      const response = await fetch(`${API}/admin/blog/${postId}`, {
        method: 'DELETE',
        credentials: 'include'
      });
      
      if (response.ok) {
        console.log('Success:', 'Article supprimé');
        fetchPosts();
      }
    } catch (error) {
      console.log('Error:', 'Erreur');
    }
  };

  const togglePublish = async (post) => {
    try {
      const response = await fetch(`${API}/admin/blog/${post.post_id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ published: !post.published })
      });
      
      if (response.ok) {
        console.log('Success:', post.published ? 'Article dépublié' : 'Article publié');
        fetchPosts();
      }
    } catch (error) {
      console.log('Error:', 'Erreur');
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-heading text-2xl font-bold text-white">Blog</h1>
        <Button 
          onClick={() => setIsCreating(true)}
          className="bg-fgs-primary hover:bg-fgs-primary-hover"
        >
          <Plus className="w-4 h-4 mr-2" />
          Nouvel article
        </Button>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-12">
          <Loader2 className="w-8 h-8 animate-spin text-fgs-primary" />
        </div>
      ) : posts.length === 0 ? (
        <div className="bg-fgs-surface border border-fgs-border rounded-xl p-12 text-center">
          <p className="text-fgs-text-muted mb-4">Aucun article de blog</p>
          <Button onClick={() => setIsCreating(true)} className="bg-fgs-primary">
            <Plus className="w-4 h-4 mr-2" />
            Créer le premier article
          </Button>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {posts.map(post => (
            <div key={post.post_id} className="bg-fgs-surface border border-fgs-border rounded-xl overflow-hidden">
              {post.image_url && (
                <img src={post.image_url} alt={post.title} className="w-full h-40 object-cover" />
              )}
              <div className="p-4">
                <div className="flex items-center justify-between mb-2">
                  <span className={`px-2 py-0.5 rounded text-xs ${
                    post.published 
                      ? 'bg-green-500/20 text-green-400' 
                      : 'bg-yellow-500/20 text-yellow-400'
                  }`}>
                    {post.published ? 'Publié' : 'Brouillon'}
                  </span>
                  <span className="text-xs text-fgs-text-muted">
                    {new Date(post.created_at).toLocaleDateString('fr-FR')}
                  </span>
                </div>
                <h3 className="font-semibold text-white mb-2 line-clamp-2">{post.title}</h3>
                <p className="text-sm text-fgs-text-muted line-clamp-2 mb-4">{post.excerpt}</p>
                <div className="flex gap-2">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setEditingPost(post)}
                    className="flex-1 border-fgs-border text-white"
                  >
                    <Edit className="w-4 h-4" />
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => togglePublish(post)}
                    className="border-fgs-border text-white"
                  >
                    {post.published ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => handleDelete(post.post_id)}
                    className="border-fgs-border text-fgs-accent hover:bg-fgs-accent/20"
                  >
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Blog Editor Modal */}
      {(editingPost || isCreating) && (
        <BlogEditor
          post={editingPost}
          isCreating={isCreating}
          onClose={() => {
            setEditingPost(null);
            setIsCreating(false);
          }}
          onSave={() => {
            fetchPosts();
            setEditingPost(null);
            setIsCreating(false);
          }}
        />
      )}
    </div>
  );
};

// Blog Editor Modal
const BlogEditor = ({ post, isCreating, onClose, onSave }) => {
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  
  const [formData, setFormData] = useState({
    title: post?.title || '',
    slug: post?.slug || '',
    excerpt: post?.excerpt || '',
    content: post?.content || '',
    image_url: post?.image_url || '',
    category: post?.category || 'actualites',
    tags: post?.tags || [],
    published: post?.published || false
  });

  const [newTag, setNewTag] = useState('');

  const generateSlug = (title) => {
    return title
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  };

  const handleTitleChange = (title) => {
    setFormData(prev => ({
      ...prev,
      title,
      slug: isCreating ? generateSlug(title) : prev.slug
    }));
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    const formDataUpload = new FormData();
    formDataUpload.append('file', file);

    try {
      const response = await fetch(`${API}/admin/upload`, {
        method: 'POST',
        credentials: 'include',
        body: formDataUpload
      });

      if (response.ok) {
        const data = await response.json();
        setFormData(prev => ({ ...prev, image_url: data.url }));
        console.log('Success:', 'Image uploadée');
      }
    } catch (error) {
      console.log('Error:', 'Erreur');
    } finally {
      setUploading(false);
    }
  };

  const addTag = () => {
    if (!newTag || formData.tags.includes(newTag)) return;
    setFormData(prev => ({
      ...prev,
      tags: [...prev.tags, newTag]
    }));
    setNewTag('');
  };

  const removeTag = (tag) => {
    setFormData(prev => ({
      ...prev,
      tags: prev.tags.filter(t => t !== tag)
    }));
  };

  const handleSubmit = async () => {
    if (!formData.title || !formData.slug) {
      console.log('Error:', 'Titre et slug requis');
      return;
    }

    setLoading(true);

    try {
      const url = isCreating 
        ? `${API}/admin/blog`
        : `${API}/admin/blog/${post.post_id}`;
      
      const response = await fetch(url, {
        method: isCreating ? 'POST' : 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        console.log('Success:', isCreating ? 'Article créé' : 'Article mis à jour');
        onSave();
      } else {
        const data = await response.json();
        console.log('Error:', data.detail || 'Erreur');
      }
    } catch (error) {
      console.log('Error:', 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  const categories = [
    { value: 'actualites', label: 'Actualités' },
    { value: 'guides', label: 'Guides' },
    { value: 'produits', label: 'Produits' },
    { value: 'securite', label: 'Sécurité' },
  ];

  return (
    <div className="fixed inset-0 bg-black/50 flex items-start justify-center z-50 overflow-y-auto py-8">
      <div className="bg-fgs-surface border border-fgs-border rounded-xl w-full max-w-4xl mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-fgs-border">
          <h2 className="font-heading text-xl font-bold text-white">
            {isCreating ? 'Nouvel article' : 'Modifier l\'article'}
          </h2>
          <button onClick={onClose} className="text-fgs-text-muted hover:text-white">
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6 max-h-[70vh] overflow-y-auto">
          {/* Title & Slug */}
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <Label className="text-fgs-text-muted text-sm">Titre *</Label>
              <Input
                value={formData.title}
                onChange={(e) => handleTitleChange(e.target.value)}
                className="bg-fgs-bg border-fgs-border text-white mt-1"
              />
            </div>
            <div>
              <Label className="text-fgs-text-muted text-sm">Slug (URL) *</Label>
              <Input
                value={formData.slug}
                onChange={(e) => setFormData(prev => ({ ...prev, slug: e.target.value }))}
                className="bg-fgs-bg border-fgs-border text-white mt-1"
              />
            </div>
          </div>

          {/* Category */}
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <Label className="text-fgs-text-muted text-sm">Catégorie</Label>
              <select
                value={formData.category}
                onChange={(e) => setFormData(prev => ({ ...prev, category: e.target.value }))}
                className="w-full mt-1 px-3 py-2 bg-fgs-bg border border-fgs-border rounded-lg text-white"
              >
                {categories.map(cat => (
                  <option key={cat.value} value={cat.value}>{cat.label}</option>
                ))}
              </select>
            </div>
            <div className="flex items-end">
              <label className="flex items-center gap-2 text-white">
                <input
                  type="checkbox"
                  checked={formData.published}
                  onChange={(e) => setFormData(prev => ({ ...prev, published: e.target.checked }))}
                  className="rounded"
                />
                Publier l'article
              </label>
            </div>
          </div>

          {/* Image */}
          <div>
            <Label className="text-fgs-text-muted text-sm mb-2 block">Image de couverture</Label>
            <div className="flex items-start gap-4">
              {formData.image_url ? (
                <img src={formData.image_url} alt="Cover" className="w-32 h-20 object-cover rounded-lg" />
              ) : (
                <div className="w-32 h-20 bg-fgs-bg border border-dashed border-fgs-border rounded-lg flex items-center justify-center">
                  <span className="text-fgs-text-muted text-xs">Pas d'image</span>
                </div>
              )}
              <div className="flex-1">
                <Input
                  value={formData.image_url}
                  onChange={(e) => setFormData(prev => ({ ...prev, image_url: e.target.value }))}
                  placeholder="URL de l'image"
                  className="bg-fgs-bg border-fgs-border text-white mb-2"
                />
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleImageUpload}
                  accept="image/*"
                  className="hidden"
                />
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  onClick={() => fileInputRef.current?.click()}
                  disabled={uploading}
                  className="border-fgs-border text-white"
                >
                  {uploading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Upload className="w-4 h-4 mr-2" />}
                  Uploader
                </Button>
              </div>
            </div>
          </div>

          {/* Excerpt */}
          <div>
            <Label className="text-fgs-text-muted text-sm">Extrait</Label>
            <textarea
              value={formData.excerpt}
              onChange={(e) => setFormData(prev => ({ ...prev, excerpt: e.target.value }))}
              rows={2}
              placeholder="Résumé de l'article pour les listings"
              className="w-full mt-1 px-3 py-2 bg-fgs-bg border border-fgs-border rounded-lg text-white"
            />
          </div>

          {/* Content */}
          <div>
            <Label className="text-fgs-text-muted text-sm">Contenu</Label>
            <textarea
              value={formData.content}
              onChange={(e) => setFormData(prev => ({ ...prev, content: e.target.value }))}
              rows={10}
              placeholder="Contenu de l'article (Markdown supporté)"
              className="w-full mt-1 px-3 py-2 bg-fgs-bg border border-fgs-border rounded-lg text-white font-mono text-sm"
            />
          </div>

          {/* Tags */}
          <div>
            <Label className="text-fgs-text-muted text-sm mb-2 block">Tags</Label>
            <div className="flex flex-wrap gap-2 mb-2">
              {formData.tags.map(tag => (
                <span key={tag} className="flex items-center gap-1 px-2 py-1 bg-fgs-primary/20 text-fgs-primary rounded text-sm">
                  {tag}
                  <button onClick={() => removeTag(tag)}>
                    <X className="w-3 h-3" />
                  </button>
                </span>
              ))}
            </div>
            <div className="flex gap-2">
              <Input
                value={newTag}
                onChange={(e) => setNewTag(e.target.value)}
                placeholder="Ajouter un tag"
                className="bg-fgs-bg border-fgs-border text-white"
                onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), addTag())}
              />
              <Button type="button" onClick={addTag} className="bg-fgs-primary">
                <Plus className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 p-6 border-t border-fgs-border">
          <Button variant="outline" onClick={onClose} className="border-fgs-border text-white">
            Annuler
          </Button>
          <Button 
            onClick={handleSubmit} 
            disabled={loading}
            className="bg-fgs-primary hover:bg-fgs-primary-hover"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Check className="w-4 h-4 mr-2" />}
            {isCreating ? 'Créer' : 'Enregistrer'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdminBlog;
